export default __webpack_public_path__ + "static/media/nf.d3f4a2c0.svg";